<div class="row">
  <div class="col-12" *ngIf="!somenteVisualizar">
    <form [formGroup]="mandatoForm" id="mandatoForm" #formElement>
      <div class="row g-3">
        <div class="col col-sm-2 form-group">
          <label for="dataInicioMandato" class="form-label">Data Início Mandato</label>
          <nz-date-picker id="dataInicioMandato" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataInicioMandato" (input)="onInputDateChange($event, 'dataInicioMandato')" [nzAllowClear]="true"></nz-date-picker>
        </div>

        <div class="col col-sm-2 form-group">
          <label for="dataFimMandato" class="form-label">Data Fim Mandato</label>
          <nz-date-picker id="dataFimMandato" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataFimMandato" (input)="onInputDateChange($event, 'dataFimMandato')" [nzAllowClear]="true"></nz-date-picker>
        </div>

        <div class="col-sm-12 form-group my-2" *ngIf="editar || desassociar">
          <label for="justificativa" class="form-label">Justificativa</label>
          <nz-input-group nzSize="large">
            <input nz-input id="justificativa" formControlName="justificativa" placeholder="Justificativa" />
          </nz-input-group>
        </div>

        <div class="col-12 d-flex justify-content-end align-items-end">
          <button nz-button nzType="primary" nzSize="large" type="button" (click)="submit()">
            {{ textoBotao() }}
          </button>

          <button nz-button nzType="default" nzSize="large" type="button" class="ms-3" (click)="reset()">
            Limpar
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-12 mt-4">
    <div class="d-flex flex-column page-content border border-radius w-100">
      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
        (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
        [nzScroll]="{ x: 'max-content' }">
        <thead>
          <tr>
            <th nzColumnKey="dataInicioMandato" nzWidth="100px">Data Início Mandato</th>
            <th nzColumnKey="dataFimMandato" nzWidth="100px">Data Fim Mandato</th>
            <th nzColumnKey="justificativa" nzWidth="100px" class="text-center">
              Justificativa
            </th>
            <th nzColumnKey="acoes" nzWidth="70px" class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataSet; let i = index">
            <td>{{ item?.dataInicioMandato | brDate }}</td>
            <td>{{ item?.dataFimMandato | brDate }}</td>
            <td class="text-center">
              <span
                nz-popover
                [nzPopoverContent]="item?.justificativa"
                nzPopoverPlacement="top"
                nzTheme="outline"
                *ngIf="item?.justificativa"
                class="justificativa-popover">
                {{ item?.justificativa | truncateText: 50 }}
              </span>
            </td>
            <td class="text-center">
              <ng-container *ngIf="!somenteVisualizar">
                <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item type="button" (click)="editarItem(item, i)">
                      <a> Editar</a>
                    </li>
                    <li nz-menu-item type="button" (click)="removerItem(item)" *ngIf="!item?.id">
                      <a> Remover</a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
          <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
